import { NavLink, useLocation } from 'react-router-dom'
import { t } from 'i18next'

interface Props {
  name: string
  link: string
  icon?: any
  isOnTopOfPage?: boolean
}

const NavbarHeaderItem = ({ name, link, icon: Icon, isOnTopOfPage }: Props) => {
  const { pathname } = useLocation()
  const isActive = pathname === link

  const classes = [
    'min-w-fill',
    'flex',
    'items-center',
    'gap-[20px]',
    'm-0',
    'transition-all',
    'duration-500',
    'base-normal',
    'py-[2px]',
    'px-[5px]',
    'border-b',
    isActive
      ? isOnTopOfPage
        ? 'text-white border-white'
        : 'text-black  border-black'
      : isOnTopOfPage
      ? 'text-white border-transparent'
      : 'text-black  border-transparent',
    'group',
  ]

  const suffixClasses = [
    'transition-all',
    'duration-500',
    'group-hover:fill-black',
    isActive ? '!fill-rose' : 'fill-dark-gray',
  ]

  return (
    <div>
      {Icon && <Icon className={suffixClasses.join(' ')} />}
      <NavLink to={link} className={classes.join(' ')}>
        <div className='grow'>{t(name)}</div>
      </NavLink>
    </div>
  )
}

export default NavbarHeaderItem
